<template>
    <div>
        <div class="modal hide fade" id="modalGetProductPurchasing" tabindex="-1" role="dialog" aria-labelledby="modalGetProductPurchasing" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Product Vendor Purchasing</h4>
                        <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button> -->
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group row">
                                    <label for="vendor_no" class="col-sm-3 col-form-label text-left">Vendor</label>
                                    <div class="col-sm-9">
                                        <select v-model="pPurch.vendor_no" id="vendor_no" class="form-control">
                                            <option v-for="v in vendorList" :key="v.id" :value="v.vendor_no">{{ v.vendor_no}} - {{ v.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="minimum_quantity" class="col-sm-3 col-form-label text-left">Quantity</label>
                                    <div class="col-sm-9">
                                        <input class="form-control" type="text" id="minimum_quantity" v-model="pPurch.minimum_quantity"/>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="amount" class="col-sm-3 col-form-label text-left">Price</label>
                                    <div class="col-sm-9">
                                        <input v-model.lazy="pPurch.amount" v-money="money" class="form-control">
                                        <!-- <input class="form-control" type="text" id="amount" v-model=""/> -->
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="amount" class="col-sm-3 col-form-label text-left">Validity</label>
                                    <div class="col-sm-3">
                                        <datetime v-model="pPurch.start_date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local"></datetime>
                                    </div>
                                    <div class="col-sm-3">
                                        <datetime v-model="pPurch.end_date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local"></datetime>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-hard-primary" data-dismiss="modal" @click="cancel">Cancel</button>
                        <button type="button" class="btn btn-soft-primary" data-dismiss="modal" @click="save">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ProductModalPrice',
  props: ['product', 'id', 'state'],
  data () {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  computed: {
    ...mapState({
      vendorList: state => state.vendors.vendorList
    }),
    pPurch: function () {
      var obj
      var index = this.product.productPurchasing.find(d => d.id === this.id)
      if (index) {
        return index
      } else {
        obj = {
          id: null,
          vendor_no: null,
          vendor: null,
          minimum_quantity: null,
          amount: null,
          start_date: null,
          end_date: null
        }
        return obj
      }
    }
  },
  methods: {
    cancel () {
      if (this.state === 'create') {
        var index = this.product.productPurchasing.findIndex(d => d.id === this.id)

        this.product.productPurchasing.splice(index, 1)
      }
    },
    save () {
      if (this.pPurch.vendor_no === null) {
        var iD = this.product.productPurchasing.findIndex(d => d.id === this.pPurch.id)
        this.product.productPurchasing.splice(iD, 1)
        this.$swal(
          'Error!!',
          'Vendor cannot null',
          'error'
        )
      } else {
        var vendor = this.vendorList.find(d => d.vendor_no === this.pPurch.vendor_no)
        this.pPurch.vendor = vendor.name
        this.pPurch.state = this.state
      }
    }
  }
}
</script>
